"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTargetAlphabetKeyEvent = void 0;
var filter_target_key_event_1 = require("./filter-target-key-event");
var filterTargetAlphabetKeyEvent = function (key) {
    return (0, filter_target_key_event_1.filterTargetKeyEvent)(key);
};
exports.filterTargetAlphabetKeyEvent = filterTargetAlphabetKeyEvent;
